import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom"
import { Row, Col, Button, Divider, message } from 'antd'
import { DownloadOutlined, LeftOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import EditCard from './EditCard'
import EditTable from './EditTable'
import "./edit.css"
import { getTrayFromBp } from '../../api/trayTable/TrayTableMethods'
import { getBpFromId } from '../../api/BPTable/BPTableMethods'
import { downloadCSV, downloadPDF } from './downloadData'
import { getFileFromBucket } from '../../api/AWS/getFile'
import { pdf } from "@react-pdf/renderer"


function Edit() {
  const { bpId, referenceId, status } = useParams();
  const navigate = useNavigate()
  const [bp, setBp] = useState<any>(undefined)
  const [data, setData] = useState<any>(undefined)
  const [bc, setBc] = useState<number>(0)
  const [bl, setBl] = useState<number>(0)
  const [update, setUpdate] = useState<boolean>(false)
  const [check, setCheckox] = useState<boolean>(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);

  useEffect(() => {
    getTray()
    getBp()
  }, [])

  useEffect(() => {
    if (data)
      countBracelets(data)
  }, [data])

  useEffect(() => {
    if (update) {
      setUpdate(false)
      getBp()
    }
  }, [update])

  const getBp = async () => {
    if (bpId) {
      let bp = await getBpFromId(bpId)
      setBp(bp)
    }
  }

  const getTray = async () => {
    if (bpId) {
      let data = await getTrayFromBp(bpId)
      countBracelets(data)
      setData(data)
    }
  }

  const countBracelets = (data) => {
    var bc = 0
    var bl = 0
    data.forEach(elem => {
      elem.skuList.forEach(i => {
        if (i?.type === "BC")
          bc += 1
        else if (i?.type === "BL")
          bl += 1
      })
    })
    setBc(bc)
    setBl(bl)
  }

  const handleCSV = () => {
    downloadCSV(data, bp?.sku)
  }

  const getImage = async (data) => {
    let photos: string[] = []
    photos.push(data.map(async (elem) => {
      const res = await getFileFromBucket(elem.photoId)
      return res
    }))
    return photos[0]
  }

  const handlePDF = async () => {
    if (selectedRowKeys.length === 0) {
      message.info("Aucun plateau n'a été séléctionné. Selectionner les plateaux à télécharger à partir de la liste")
    } else {
      let download: any[] = []
      download.push(selectedRowKeys.map((id) => data.find((elem: { _id: any }) => elem._id === id)))
      const photos = await getImage(download[0]);
      let blob = await pdf(downloadPDF(download[0], photos)).toBlob()
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      const url = window.URL.createObjectURL(blob)
      a.href = url;
      a.download = "BP " + bpId + ".pdf";
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }

  return (
    <Row className='edit-row'>
      <Col xs={18}>
        <Button id="edit-back-button" icon={<LeftOutlined />} onClick={() => { navigate("/inventory") }} className='edit-back-button'>
          Retour a l'inventaire
        </Button>
      </Col>
      <Col xs={6}>
        <span className='edit-download'>
          <DownloadOutlined />
          Telecharger
        </span>
        <span onClick={handleCSV} className='edit-download-type edit-download-csv'>CSV</span>
        <Divider type='vertical' className='download-divider' />
        <span onClick={handlePDF} className='edit-download-type'>PDF</span>
      </Col>
      <Col xs={24}>
        <EditCard bpId={bpId} referenceId={referenceId} count={data ? data.length : 0} bc={bc} bl={bl} bp={bp} setUpdate={setUpdate} />
      </Col>
      <Col xs={24}>
        {data &&
          <EditTable data={data} setData={setData} check={check} selectedRowKeys={selectedRowKeys} setSelectedRowKeys={setSelectedRowKeys} />
        }
      </Col>
    </Row>
  )
}

export default Edit